const getEntityStats = require('./stats');

const HUB_LIMITS = {
  TIER_LIST: 48,
  PATCH: 4,
  ENTITY: 12,
  POST: 4
};

// Returns true if the character should be filtered out of display
const isFiltered = (entity, stats, searchText, filters) => {
  if (!entity || !entity.name) return;
  const survivesSearch = entity.name.toLowerCase().includes(searchText.toLowerCase());
  let survivesFilters = true;

  if (filters.length !== 0) {
    survivesFilters = false;

    filters.forEach(filter => {
      const entityStat = stats && stats[filter.name];
      if (Array.isArray(entityStat)) {
        entityStat.forEach(stat => {
          if (filter.values.includes(stat)) {
            survivesFilters = true;
          }
        });
      } else if (filter.values.includes(entityStat)) {
        survivesFilters = true;
      }
    });
  }

  return !survivesSearch || !survivesFilters;
};

const filterEntities = (entitiesToCheck, searchText, filters) => {
  if (!entitiesToCheck) return [];
  if (searchText === '' && filters.length === 0) return entitiesToCheck;

  return entitiesToCheck.filter(entity => {
    return !isFiltered(
      entity,
      getEntityStats({ entity, entitiesWithStats: entitiesToCheck }),
      searchText,
      filters
    );
  });
};

const filterLowQualityTierLists = tierlists => {
  return (
    tierlists &&
    tierlists.filter(tierlist => {
      const tiers =
        tierlist.tierJSON &&
        tierlist.tierJSON.dimensions &&
        tierlist.tierJSON.dimensions[0] &&
        tierlist.tierJSON.dimensions[0].tiers;

      const characters =
        tiers &&
        tiers.reduce((characterAccumulator, tier) => {
          return characterAccumulator.concat(tier.characters);
        }, []);

      if (!characters || (characters && characters.length <= 3)) {
        return false;
      }
      return true;
    })
  );
};

const filterLowQualityPosts = posts => {
  const qualityPosts =
    posts &&
    posts.filter(post => {
      if (!post.author || post.content) {
        // these are pre-guidebuilder posts, we let them in
        return true;
      }

      if (post.contentJSON && post.contentJSON.blocks) {
        const blocks = post.contentJSON.blocks;
        const numBlocksToAutopass = 3;
        const minimumQualityScore = numBlocksToAutopass * 30; // arbitrary

        if (blocks.length === 0) return false;

        if (blocks.length > numBlocksToAutopass) return true; // probably ok

        if (blocks.length <= numBlocksToAutopass) {
          let qualityScore = 0;
          blocks.forEach(block => {
            if (block.type === 'entity') {
              // count how many entities are in this block
              qualityScore += 25 * Object.keys(block.data.entities).length;
            }

            if (block.type === 'paragraph') {
              if (block.data && block.data.text) {
                qualityScore += block.data.text.length;
              }
            }
          });
            
          if (qualityScore > minimumQualityScore) return true;
        }
      }

      return false;
    });

  const postResult =
    qualityPosts &&
    qualityPosts.map(post => {
      return { ...post, content: null, contentJSON: null };
    });

  return postResult;
};

module.exports = {
  isFiltered,
  filterEntities,
  filterLowQualityTierLists,
  filterLowQualityPosts,
  HUB_LIMITS
};
